import { LINKEDIN_SHARE_LIST_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function linkedinShareListData(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case LINKEDIN_SHARE_LIST_SUCCESS:
     
      // const parsedData = JSON.parse(action.payload.data)
      
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}